export default __webpack_public_path__ + "static/media/switched-tab.bd123d53.svg";